import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=008474e2&scoped=true"
import script from "./EditGroup.vue?vue&type=script&lang=js"
export * from "./EditGroup.vue?vue&type=script&lang=js"
import style0 from "./EditGroup.vue?vue&type=style&index=0&id=008474e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008474e2",
  null
  
)

export default component.exports